export const pagesQueryKeys = {
    pagesList: 'pagesList',
    siteMapList: 'siteMapList',
}